<template>
  <div v-if="images !== undefined" class="slideshow">
    <div v-if="images.length" ref="sliderContainer" class="slideshow__slider">
      <section v-for="(slide, index) in images" :key="`slideshow__slide--${index}`" class="slideshow__slide">
        <div class="slideshow__slide-image">
          <ResponsiveImage :image="slide" />
        </div>
      </section>
      <button class="slideshow__arrow slideshow__arrow--left" @click="slider?.prev()">
        <Icon name="ArrowOutlineLeft" />
      </button>
      <button class="slideshow__arrow slideshow__arrow--right" @click="slider?.next()">
        <Icon name="ArrowOutlineRight" />
      </button>
    </div>
    <div v-if="slider" class="slideshow__dots">
      <button
        v-for="(_slide, idx) in dotHelper"
        :key="idx"
        class="slideshow__dot"
        :class="{ dot: true, 'slideshow__dot--active': current === idx }"
        @click="slider.moveToIdx(idx)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  images: any
}>()

const current = ref(1)

const dotHelper = computed(() => slider.value ? [...Array(slider.value.track.details.slides.length).keys()] : [])

const sliderOptions = {
  loop: true,
  drag: true,
  selector: '.slideshow__slide',
  slides: {
    perView: 1,
    spacing: 30
  }
}

const [sliderContainer, slider] = useKeenSlider({
  ...sliderOptions,
  slideChanged: (s) => {
    current.value = s.track.details.rel
  }
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.slideshow {
  @include tools.page-grid-columns;
  position: relative;

  &__slider {
    display: flex;
    overflow: hidden;
    align-items: center;
  }

  &__slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space--sm) ;

  }

  &__slide-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  &__slide-caption {
    @include tools.typo-small;

    p {
      @include tools.typo-small;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  &__arrow {
    position: absolute;
    display: flex;
    top:0;
    bottom: 0;
    left: 0;
    align-items: center;
    border: 0;
    background-color: transparent;
    border-radius: 0;
    cursor: pointer;
    box-shadow: none;

    &:hover {
      color: var(--color-black);
      background-color: transparent;
    }

    &--right {
      right: 0;
      left: auto;
    }
  }

  &__dots {
    display: flex;
    justify-content: center;
    gap: var(--space--s);
    margin-top: var(--space--s);
  }

  &__dot {
    width: 13px;
    height: 13px;
    padding: 0;
    background-color: var(--color-background);
    border-radius: 50px;
    box-shadow: none;

    &--active {
      background-color: var(--color-black);
    }
  }
}
</style>
